import { LucideIcon, LucideProps } from 'lucide-react';
import { cn } from '@/utils/cn';

export interface IconProps extends LucideProps {
  icon: LucideIcon;
}

export const Icon = ({ icon: Icon, className, size = 24, ...props }: IconProps) => {
  return (
    <Icon
      className={cn('flex-shrink-0', className)}
      size={size}
      aria-hidden="true"
      {...props}
    />
  );
}; 